import React from 'react';
import PropTypes from 'prop-types';
import { PeopleSearchShape } from '../../shapes';
import CommentPeopleMenuItem from './comment_people_menu_item';

export default class CommentPeopleMenu extends React.Component {

  constructor(props) {
    super(props);
    this.onKeyDown = this.onKeyDown.bind(this);
  }

  static propTypes = {
    peopleTextSearchString: PropTypes.string,
    peopleSearchObject: PeopleSearchShape,
    onSearchForPeople: PropTypes.func,
    onSelectPerson: PropTypes.func
  }

  state = {
    selectedPersonIndex: 0,
    show: true
  };

  componentDidUpdate(prevProps) {
    if (this.props.peopleTextSearchString && (prevProps.peopleTextSearchString !== this.props.peopleTextSearchString)) {
      this.props.onSearchForPeople(this.props.peopleTextSearchString);
    }
  }

  componentDidMount() {
    document.addEventListener("keydown", this.onKeyDown);
  }

  componentWillUnmount() {
    document.removeEventListener("keydown", this.onKeyDown);
  }

  render() {
    if (this.state.show && this.props.peopleSearchObject && this.props.peopleSearchObject.get('suggestedPeople').size > 0) {
      return this.renderPeopleModal();
    } else {
      return null;
    }
  }

  renderPeopleModal() {
    const peopleResults = this.props.peopleSearchObject.get('suggestedPeople').map((suggestedPerson, i) => {
      return (
        <li key={ i } className='list-group-item' onClick={ (e) => { e.preventDefault(); this.onSelectPerson(i) } }><CommentPeopleMenuItem user={ suggestedPerson } highlighted= { this.state.selectedPersonIndex == i } /></li>
      )
    });
    return (
      <div className='comment-people-modal col-sm-5'>
        <a href='#' className='close-modal secondary-background' onClick={ (e) =>  { e.preventDefault(); this.setState({ show: false }) } }>close</a>
        <ul className="list-group">
          { peopleResults }
        </ul>
      </div>
    );
  }

  onSelectPerson(selectedPersonIndex) {
    this.setState({ show: false });
    this.props.onSelectPerson(this.props.peopleSearchObject.get('suggestedPeople').get(selectedPersonIndex));
  }

  onKeyDown(e) {
    const selectedPersonIndex = this.state.selectedPersonIndex;
    const peopleOptionsLength = this.props.peopleSearchObject.get('suggestedPeople').size;
    switch (e.key) {
      case "Enter": {
        e.preventDefault();
        this.onSelectPerson(selectedPersonIndex);
        break;
      }
      case "ArrowUp": {
        e.preventDefault();
        const prevSelected = (selectedPersonIndex === 0) ? peopleOptionsLength - 1 : selectedPersonIndex - 1;
        this.setState({ selectedPersonIndex: prevSelected });
        break;
      }
      case "ArrowDown":
      case "Tab": {
        e.preventDefault();
        const nextSelected = (selectedPersonIndex === peopleOptionsLength - 1) ? 0 : selectedPersonIndex + 1;
        this.setState({ selectedPersonIndex: nextSelected });
        break;
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/comments/comment_people_menu.jsx